import { render, staticRenderFns } from "./Overnight-travel.vue?vue&type=template&id=08fcbe00"
import script from "./Overnight-travel.vue?vue&type=script&lang=js"
export * from "./Overnight-travel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports